import { Button, type ButtonProps } from '@chakra-ui/react';

/**
 * The destructive counterpart to OutlinedButton — decline, revoke, remove.
 *
 * Styling: `visual.dangerOutline`, which follows the colour mode rather than pinning a white
 * background the way this button's earlier form did.
 */
const CancelOutlinedButton = (props: ButtonProps) => <Button visual="dangerOutline" {...props} />;

export default CancelOutlinedButton;
